import {
  PULLET_INVENTORY_UPDATE_FAIL,
  PULLET_INVENTORY_UPDATE_REQUEST,
} from "../pullet/actionType";
import { updatePullet } from "../pullet/actions";
import axios from "./utils/axios";

const fetchPulletUpdate = (inventory_id, pullet) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PULLET_INVENTORY_UPDATE_REQUEST });
      const {
        login: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `api/pullet/update-inventory/${inventory_id}/`,
        pullet,
        config
      );
      dispatch(updatePullet(data));
    } catch (error) {
      dispatch({
        type: PULLET_INVENTORY_UPDATE_FAIL,
        payload:
          error.response && error.response.data.details
            ? error.response.data.details
            : error.message,
      });
    }
  };
};
export default fetchPulletUpdate;
